<template>
  <div class="flex w-full flex-row">
    <div
      v-for="(step, index) in timelineSteps"
      :key="step.id"
      class="flex min-w-0 grow basis-0 flex-col"
      :class="[
        index === 0 && 'grow',
        index === timelineSteps.length - 1 && 'grow',
        index !== 0 && index !== timelineSteps.length - 1 && 'grow-2',
      ]"
    >
      <div class="flex flex-row items-center gap-2">
        <div
          v-if="index > 0"
          class="h-1 grow rounded-r-full"
          :class="lineClass(index <= activeTimelineIndex)"
        ></div>
        <BaseShapeMask
          v-if="step.state === 'current'"
          shape="flower"
          animation="spin"
          class="text-primary -m-1 shrink-0"
        >
          <div class="bg-primary h-7 w-7"></div>
        </BaseShapeMask>
        <div
          v-else-if="step.state === 'done'"
          class="border-primary bg-primary flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2"
        >
          <BaseIcon size="16" class="text-on-primary">check</BaseIcon>
        </div>
        <div
          v-else
          class="border-outline-variant flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-4"
        ></div>
        <div
          v-if="index < timelineSteps.length - 1"
          class="h-1 grow rounded-l-full"
          :class="lineClass(index < activeTimelineIndex)"
        ></div>
      </div>
      <div
        class="flex flex-col pt-1 text-center"
        :class="[
          index === 0 && 'items-start',
          index === timelineSteps.length - 1 && 'items-end',
          index !== 0 && index !== timelineSteps.length - 1 && 'items-center',
        ]"
      >
        <span
          class="text-title-small"
          :class="[
            index <= activeTimelineIndex && 'text-on-surface',
            index > activeTimelineIndex && 'text-on-surface-variant',
          ]"
          >{{ step.title }}</span
        >
        <span
          v-if="step.subInformation?.length"
          class="text-body-small text-on-surface-variant -mt-0.5"
        >
          <p v-for="(information, key) in step.subInformation" :key="key">
            {{ information }}
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
  import type { Dialog } from '@/core/models/dialog/dialog'
  import { useCoacheeDialogTimeline } from '@/modules/coachees/composables/use-coachee-dialog-timeline'

  interface Props {
    dialog: Omit<Dialog, 'coachee' | 'coach'>
  }

  const props = defineProps<Props>()

  const { timelineSteps, activeTimelineIndex, lineClass } = useCoacheeDialogTimeline(
    () => props.dialog,
  )
</script>
